import type { NuxtI18nInstance } from 'nuxt-i18n';

// eslint-disable-next-line import/no-mutable-exports
let i18nInstance: NuxtI18nInstance;

export function initializeI18n(i18n: NuxtI18nInstance) {
  i18nInstance = i18n;
}

export { i18nInstance };
